import { BaseTable, DashboardFilter, FooterMenu, HeaderMenu, PaginationData, TableHeader } from "components"
import moment from "moment"
import { useState } from "react"
import { DashboardFillType, PaginationState } from "types"
import { usePromiseToCome } from "./utils/hooks/usePromiseToCome"
import { convertNumber, default_pagination_value, exportPdf } from "utils"
import { ExportExcelPromiseToCome, ExportPdfPromiseToCome } from "./components"

type FilterType = DashboardFillType & PaginationState

export function PromiseToCome() {
    const month = moment().format("MM")
    const year = moment().format("YYYY")
    const [fill, setFill] = useState<FilterType>({
        ...default_pagination_value,
        month,
        year,
    })
    const location_id = fill?.location_id

    const { data, pagination, fetchAll } = usePromiseToCome({
        location_id: location_id,
        page: fill.page,
        limit: fill.limit
    })

    return (
        <section className="container my-5 flex flex-col gap-3">
            <HeaderMenu title="PURCHASE ORDER PROMISES TO COME" />

            <section className="flex flex-col gap-3">
                <section>
                    <DashboardFilter
                        onChangeFilter={(res) => setFill({
                            ...fill,
                            month: moment(res.date_from).format("MM"),
                            year: moment(res.date_from).format("YYYY"),
                            location_id: res.location_id
                        })}
                    />
                </section>

                <section className="flex flex-col mt-5">
                    <div className="flex items-center justify-between mt-3 mb-5">
                        <div className="text-center text-lg font-bold">PURCHASE ORDER PROMISES TO COME</div>
                    </div>

                    <section className="grow">
                        <div className="max-h-[600px] overflow-y-auto">
                            <BaseTable>
                                <TableHeader>
                                    <tr>
                                        <th>CODE</th>
                                        <th>VENDOR NAME</th>
                                        <th>PO ID</th>
                                        <th>ORDER DATE</th>
                                        <th>TOTAL QTY</th>
                                        <th>PROMISED DATE</th>
                                    </tr>
                                </TableHeader>
                                <tbody>
                                    {data?.data?.map(performence => (
                                        <tr>
                                            <td className="text-left">{performence?.vendor_code ?? "-"}</td>
                                            <td className="text-left">{performence?.vendor_name ?? "-"}</td>
                                            <td>{performence?.trx_code ?? "-"}</td>
                                            <td>{performence?.transaction_date ? moment(performence.transaction_date).format("DD/MM/YYYY") : "-"}</td>
                                            <td className="text-center">{convertNumber(performence?.total_qty || 0)?.intoNormalAmount ?? "-"}</td>
                                            <td>{performence?.promize_date ? moment(performence.promize_date).format("DD/MM/YYYY") : "-"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </BaseTable>
                        </div>
                        <div className="mt-5">
                            <PaginationData
                                data={{
                                    pagination_data: pagination
                                }}
                                pagination={fill}
                                setPagination={setFill as React.Dispatch<React.SetStateAction<PaginationState>>}
                            />
                        </div>
                    </section>
                </section>
                <section className="mt-2">
                    <FooterMenu
                        export={{
                            actiontype: "export",
                            onClick: async () => {

                                const fullData = await fetchAll();

                                ExportExcelPromiseToCome({
                                    dataList: fullData.data || [],
                                })
                            }
                        }}
                        pdf={{
                            actiontype: "pdf",
                            onClick: async () => {
                                const fullData = await fetchAll();
                                exportPdf({
                                    documentComponent: <ExportPdfPromiseToCome dataList={fullData.data || []} />,
                                    fileName: "Purchase_Order_Promises_to_come"
                                })
                            }
                        }}
                    />
                </section>
            </section>
        </section>
    )
}